export enum APP_ROUTES {
  root = '',
  textTranslation = 'text-translation',
  textRephrase = 'text-rephrase',
  error = 'error',
  fileUpload = 'file-upload',
  glossary = 'glossary',
}
